import { Card, Collapsible, Flex, SvgIcon } from '@volue/wave-react';
import React from 'react';

type CollapsibleCardState = 'EXPANDED' | 'COLLAPSED';

export const isVisible = (
  collapsibleContainerState: Parameters<
    React.ComponentProps<typeof CollapsibleContainer>['children']
  >['1']
) => collapsibleContainerState === 'EXPANDED';

type CollapsibleContainerProps = { expandedByDefault?: boolean };
export const CollapsibleContainer: React.FunctionComponent<
  CollapsibleContainerProps & {
    children: (
      toggle: () => void,
      containerState: CollapsibleCardState
    ) => JSX.Element | React.ReactNode;
  }
> = props => {
  const expandedByDefault = props.expandedByDefault || false;
  const [summaryPanelState, setSummaryPanelState] =
    React.useState<CollapsibleCardState>(
      expandedByDefault ? 'EXPANDED' : 'COLLAPSED'
    );

  const handleOnPanelToggle = (
    summaryPanelState: CollapsibleCardState,
    setSummaryPanelState: React.Dispatch<CollapsibleCardState>
  ) => {
    if (summaryPanelState === 'COLLAPSED') {
      setSummaryPanelState('EXPANDED');
    } else if (summaryPanelState === 'EXPANDED') {
      setSummaryPanelState('COLLAPSED');
    }
  };
  return (
    <Collapsible
      isOpen={summaryPanelState === 'EXPANDED'}
      onIsOpenChange={isOpen =>
        isOpen
          ? setSummaryPanelState('EXPANDED')
          : setSummaryPanelState('COLLAPSED')
      }
    >
      {props.children(
        () => handleOnPanelToggle(summaryPanelState, setSummaryPanelState),
        summaryPanelState
      )}
    </Collapsible>
  );
};
type CollapsibleCardProps = {
  header: JSX.Element | React.ReactNode;
  content: JSX.Element | React.ReactNode;
  expandedByDefault?: boolean;
};
export function CollapsibleCard(props: CollapsibleCardProps) {
  const expandedByDefault = props.expandedByDefault || false;
  return (
    <CollapsibleContainer expandedByDefault={expandedByDefault}>
      {(toggle, currentState) => (
        <Card
          className="is-actionable"
          css={{
            '&:before': {
              boxShadow: 'inset 0 0 0 1px var(--colors-colorAccent70)'
            }
          }}
        >
          <Card.Header
            onClick={() => toggle()}
            css={{ color: '$colorAccent120' }}
          >
            <Flex main={'space-between'} cross={'center'}>
              {props.header}
              <SvgIcon
                iconName={
                  currentState === 'EXPANDED' ? 'chevronDown' : 'chevronUp'
                }
              />
            </Flex>
          </Card.Header>
          <Card.Body>
            <Collapsible.Panel>
              <Flex flow="column">{props.content}</Flex>
            </Collapsible.Panel>
          </Card.Body>
        </Card>
      )}
    </CollapsibleContainer>
  );
}
